
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import Rating from '@/components/Rating'
import { Playground, PropsTable } from 'docz'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"rating"}}>{`Rating`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"onclick-reports-which-pip-was-clicked"}}>{`onClick reports which pip was clicked`}</MDXTag>
<Playground __position={0} __code={'<Rating onChange={which => window.alert(which)} />'} __scope={{props: this ? this.props : props,Rating}}>
  <Rating onChange={which => window.alert(which)} />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"current-less-than-maximum"}}>{`Current less than Maximum`}</MDXTag>
<Playground __position={1} __code={'<Rating current={3} maximum={10} />'} __scope={{props: this ? this.props : props,Rating}}>
  <Rating current={3} maximum={10} />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"current-greater-than-maximum-with-allowexcess-disabled"}}>{`Current greater than Maximum, with allowExcess disabled`}</MDXTag>
<Playground __position={2} __code={'<Rating current={12} maximum={10} />'} __scope={{props: this ? this.props : props,Rating}}>
  <Rating current={12} maximum={10} />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"current-greater-than-maximum-with-allowexcess-enabled"}}>{`Current greater than Maximum, with allowExcess enabled`}</MDXTag>
<Playground __position={3} __code={'<Rating current={9} maximum={5} allowExcess />'} __scope={{props: this ? this.props : props,Rating}}>
  <Rating current={9} maximum={5} allowExcess />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"icons-are-configurable-via"}}>{`Icons are configurable via`}</MDXTag>
<Playground __position={4} __code={'<Rating\n  current={3}\n  maximum={5}\n  iconOff=\"☆\"\n  iconOn=\"★\"\n  iconExcess=\"🌟\"\n  allowExcess\n/>\n<Rating\n  current={7}\n  maximum={5}\n  iconOff=\"☆\"\n  iconOn=\"★\"\n  iconExcess=\"🌟\"\n  allowExcess\n/>'} __scope={{props: this ? this.props : props,Rating}}>
  <Rating current={3} maximum={5} iconOff='☆' iconOn='★' iconExcess='🌟' allowExcess />
  <Rating current={7} maximum={5} iconOff='☆' iconOn='★' iconExcess='🌟' allowExcess />
</Playground>
           </MDXTag>
  }
}
  